<template>
  <div class="comments-level">
    <div v-for="comment in comments" :key="comment.id" class="comment-wrapper">
      <comment
        :comment="comment"
        :postId="postId"
        :auth="auth"
      ></comment>

      <comments-level class="child-comments"
        v-if="comment.comments && comment.comments.length"
        :comments="comment.comments"
        :postId="postId"
        :auth="auth"
      ></comments-level>
    </div>
  </div>
</template>

<script>

import Comment from './Comment';

export default {
  name: 'comments-level',
  components: {
    Comment,
  },
  props: {
    comments: {
      type: Array,
      required: true,
    },
    postId: {
      required: true,
    },
    auth: {
      required: true,
      type: Object,
    },
  },
};

</script>

<style scoped>

.child-comments {
  margin-left: 40px;
  margin-top: -15px;
}

.comment-wrapper {
  background: #fcfcfc;
}

</style>



// WEBPACK FOOTER //
// src/components/Comments/CommentsLevel.vue